import { Grid } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { UserRecord } from '@tassat/fred-definitions';
import { Lock as LockIcon, Wallet as WalletIcon } from '@tassat/icon';
import React from 'react';

import { LOCK_ICON_COLOR } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface UserStatusCellRendererProps{
    value: UserRecord;
}

const muiStyles = makeStyles({
    root: {
        height: '100%',
        paddingLeft: '.25rem'
    },
    status: { marginRight: '1.25rem' }
});

export const UserStatusCellRenderer = (props: UserStatusCellRendererProps) => {
    const { value } = props;

    const classes = muiStyles(props);
    const theme = useTheme<ApplicationMuiTheme>();
    const user = value;

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='row'
            spacing={0}
            wrap='nowrap'
        >
            {user.IsLocked &&
                <LockIcon
                    className={classes.status}
                    iconColor={theme?.app?.applicationColors.lockColor || LOCK_ICON_COLOR}
                />}
            {!user.IsAdmin && user.IsFrozen &&
                <WalletIcon
                    className={classes.status}
                    iconColor={theme?.app?.applicationColors.lockColor || LOCK_ICON_COLOR}
                />}
        </Grid>
    );
};

export default UserStatusCellRenderer;